import { render, staticRenderFns } from "./ItemTypesEditForm.vue?vue&type=template&id=0ead84a7"
import script from "./ItemTypesEditForm.vue?vue&type=script&lang=js"
export * from "./ItemTypesEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports